import React, { useEffect, useState } from 'react';

//Material
import { Box, Grid, Modal, Rating, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './PostModal.css';
import { connect } from 'react-redux';
import ApiService from '../../helpers/apiHelper';
import { LetsGoBtn } from '../../components/Buttons';
import styled from '@emotion/styled';

const style = {
  position: 'fixed',
  top: '70%',
  left: { xs: 'calc(100% - 499vw / 2)', sm: '70%', md: '80%' },
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 436,
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: '24px',
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '408px',
  minHeight: '408px',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function FeedbackModal({ isOpenModal, setIsOpenModal, userData }) {
  const [screenType, setScreenType] = useState('desktop');
  const [description, setDescription] = useState('');
  const [rating, setRating] = useState(0);

  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);

  const apiSendMessage = new ApiService('mail/send-message');

  return (
    <div>
      <Modal
        hideBackdrop
        disableBackdropClick
        disableScrollLock={true}
        disableAutoFocus
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          setIsOpenModal(false);
          localStorage.removeItem('feedbackModal');
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_post_modal"
        sx={{
          width: 'fit-content'
        }}
      >
        <Box sx={style}>
          <CloseIcon
            className="bonfair_post_modal-close"
            style={{
              position: 'absolute',
              right: '10px',
              top: '10px',
              cursor: 'pointer',
              zIndex: '1000'
            }}
            onClick={() => {
              setIsOpenModal(false);
              localStorage.removeItem('feedbackModal');
            }}
          />

          <Grid container spacing={screenType !== 'desktop' ? 1 : 1} sx={{ width: '100%', m: 0 }}>
            <Grid item xs={12} md={12} lg={12} sx={{ mb: 1 }}>
              <Typography
                sx={{
                  textAlign: 'center',
                  margin: '10px !important',
                  fontFamily: 'FixelText-SemiBold',
                  fontSize: { xs: '24px', sm: '28px' }
                }}
              >
                Зворотній звʼязок
              </Typography>

              <Typography sx={{ margin: '0 auto' }} fontSize={16} textAlign="center">
                Оцініть будь ласка
              </Typography>
              <Typography
                sx={{ margin: '0 auto', color: '#7C7C7C' }}
                fontSize={14}
                textAlign="center"
              >
                Ми дуже старались над розробкою платформи і будемо раді вашому фідбеку
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              style={{ padding: '0px', display: 'flex', justifyContent: 'center' }}
              sx={{ mb: 1, mt: 1 }}
            >
              <Rating
                value={rating}
                onChange={(event, value) => setRating(value)}
                precision={0.5}
              />
            </Grid>
            <Grid item xs={12} style={{ padding: '0px' }} sx={{ mb: 1, mt: 0 }}>
              <CssTextField
                placeholder="Повідомлення"
                multiline
                rows={3}
                fullWidth
                inputProps={{ style: { textAlign: 'left' } }}
                onChange={(e) => e.target.value.length <= 1000 && setDescription(e.target.value)}
                value={description}
                InputProps={{
                  endAdornment: (
                    <p
                      style={{ fontFamily: 'FixelText-Regular', fontSize: '14px', margin: '0' }}
                    >{`${description.length}/1000`}</p>
                  )
                }}
              >
                {description}
              </CssTextField>
            </Grid>
            <Grid item xs={12} style={{ padding: '0px' }} sx={{ mb: 1, mt: 1 }}>
              <LetsGoBtn
                text="Відправити"
                width="100%"
                onClick={() => {
                  apiSendMessage
                    .sendRequest({
                      name: userData?.nickname,
                      subject: 'Feedback',
                      contact: userData.email,
                      text: `Оцінка: ${rating} - ${description}`,
                      type: 'DataMessage'
                    })
                    .then((res) => {
                      localStorage.removeItem('feedbackModal');
                      setIsOpenModal(false);
                    })
                    .catch((error) => {
                      console.error(error);
                    });
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps)(FeedbackModal);
